"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Rules_1 = require("./_Rules");
exports.GetBucketLifecycleOutput = {
    type: "structure",
    required: [],
    members: {
        Rules: {
            shape: _Rules_1._Rules,
            locationName: "Rule"
        }
    }
};
//# sourceMappingURL=GetBucketLifecycleOutput.js.map